import { resolveDataTenantId } from './platformViewTenant.js';

/** 当前业务数据租户（平台管理员优先用切换租户，与 api.js 拦截器一致） */
export const resolveTenantId = () => resolveDataTenantId();

/** 构造带 tenantId 的 query/body 参数 */
export const tenantParams = (extra = {}) => ({ tenantId: resolveTenantId(), ...extra });

export { getTenantId, getTenantIdFromToken } from './token.js';
